import React from "react";
import { useTranslation } from "react-i18next";
import { UserTab } from "../../userSlice";
import Icon from "../../../../common/components/Icon/Icon";

interface ProfileSidebarProps {
  activeTab: UserTab;
  onTabChange: (tab: UserTab) => void;
  onLogout: () => void;
}

const ProfileSidebar: React.FC<ProfileSidebarProps> = ({
  activeTab,
  onTabChange,
  onLogout,
}) => {
  const { t } = useTranslation();

  const navItems = [
    {
      key: "dashboard",
      icon: "house",
      label: t("user.dashboard.nav.dashboard", "Dashboard"),
    },
    {
      key: "orders",
      icon: "shopping-bag", // Reusing standard shopping bag/cart icon
      label: t("user.dashboard.nav.orders", "Orders"),
    },
    {
      key: "addresses",
      icon: "map-pin-filled",
      label: t("user.dashboard.nav.addresses", "Addresses"),
    },
    {
      key: "account",
      icon: "cog-filled",
      label: t("user.dashboard.nav.accountDetails", "Account Details"),
    },
    {
      key: "coupons",
      icon: "ticket-outlined",
      label: t("user.dashboard.nav.coupons", "My Coupons"),
    },
  ];

  return (
    <aside className="profile-sidebar">
      <nav className="profile-nav">
        {navItems.map((item) => (
          <button
            key={item.key}
            className={`profile-nav__item ${
              activeTab === item.key ? "is-active" : ""
            }`}
            onClick={() => onTabChange(item.key as UserTab)}
          >
            <Icon
              iconName={item.icon}
              className={
                item.icon.includes("filled")
                  ? "icon--filled"
                  : "icon--stroke-thick"
              }
            />
            <span>{item.label}</span>
          </button>
        ))}
        <button
          className="profile-nav__item profile-nav__item--logout"
          onClick={onLogout}
        >
          <Icon iconName="external-link" className="icon--stroke-thick" />
          <span>{t("user.dashboard.nav.logout", "Logout")}</span>
        </button>
      </nav>
    </aside>
  );
};

export default ProfileSidebar;
